const formatPrice = price => {
  //   if (price < 100000) return `₹${price.toLocaleString()}`;
  return Math.abs(price) > 99999
    ? `₹${Math.sign(price) * (Math.abs(price) / 100000).toFixed(1)}L`
    : `₹${parseInt(price, 10).toLocaleString()}`;
};

export default formatPrice;
